import React from "react";

const Header = () => {
  return (
    <header className="spettacolo__header">
      <div className="spettacolo__header-left">
        <div className="spettacolo__info-line">
          <span className="spettacolo__info-text">SPETTACOLO</span>
        </div>
        <div className="spettacolo__info-line">
          <span className="spettacolo__info-text">
            An artist-run project space by Ida Ekblad.
          </span>
        </div>
      </div>
{/* 
      <div className="spettacolo__header-center">
        <div className="spettacolo__info-line">
          <span className="spettacolo__info-text">Joe Bradley — Vyakti</span>
        </div>
        <div className="spettacolo__info-line">
          <span className="spettacolo__info-text">
            May 21st - August 16th 2026
          </span>
        </div>
      </div> */}
    </header>
    // <header className="spettacolo__header">
    //   <h1>Spettacolo</h1>
    // </header>
  );
};

export default Header;
